import React from 'react';
import { Card, Box, Typography, Chip } from '@mui/material';
import { COLOR, COLOR_ESTADO, FUENTE } from './tokens';

/**
 * Fila de KPIs ejecutivos con comparación contra período anterior y meta.
 * @param {{items: Array<{
 *   label: string,
 *   value: string|number,
 *   unit?: string,
 *   deltaPct?: number|null,
 *   deltaLabel?: string,
 *   isGood?: boolean,
 *   hint?: string,
 * }>}} props
 */
const KpiRow = ({ items }) => (
    <Box
        sx={{
            display: 'grid',
            // Sin esto, dentro de una columna flex la grilla tomaba el ancho de su contenido y se
            // salía de la pantalla en celular (pasaba en Reportes ANSES: 342 px en un lugar de 283).
            width: '100%',
            minWidth: 0,
            gridTemplateColumns: { xs: 'repeat(2, minmax(0, 1fr))', md: `repeat(${items.length}, minmax(0, 1fr))` },
            gap: '16px',
        }}
    >
        {items.map((item, index) => (
            <Card
                key={item.label}
                variant="outlined"
                sx={{
                    border: `1px solid #e2e8f0`, borderRadius: '12px', boxShadow: 'none', padding: '16px 18px',
                    // El primer KPI (el más importante) ocupa la fila completa en mobile —
                    // mismo patrón "1 principal + grilla" que Panel Diario y Trámites.
                    gridColumn: { xs: index === 0 ? 'span 2' : 'span 1', md: 'span 1' },
                }}
            >
                <Typography
                    sx={{
                        fontFamily: FUENTE, fontSize: 11, fontWeight: 700, textTransform: 'uppercase',
                        letterSpacing: '0.07em', color: COLOR.grisTexto, marginBottom: '6px',
                    }}
                >
                    {item.label}
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'baseline', gap: '4px' }}>
                    <Typography
                        sx={{ fontFamily: FUENTE, fontSize: 29, fontWeight: 700, color: COLOR.negro, fontVariantNumeric: 'tabular-nums', lineHeight: 1 }}
                    >
                        {item.value}
                    </Typography>
                    {item.unit && (
                        <Typography sx={{ fontFamily: FUENTE, fontSize: 13, color: COLOR.grisTexto }}>{item.unit}</Typography>
                    )}
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '8px', flexWrap: 'wrap' }}>
                    {item.deltaPct !== null && item.deltaPct !== undefined && (
                        <Chip
                            size="small"
                            label={`${item.deltaPct > 0 ? '▲' : item.deltaPct < 0 ? '▼' : '–'} ${Math.abs(item.deltaPct).toFixed(1)}%`}
                            sx={{
                                height: 20,
                                fontFamily: FUENTE,
                                fontSize: 11.5,
                                fontWeight: 700,
                                fontVariantNumeric: 'tabular-nums',
                                backgroundColor: item.isGood ? COLOR_ESTADO.verdeFondo : COLOR_ESTADO.rojoFondo,
                                color: item.isGood ? COLOR_ESTADO.verdeTexto : COLOR_ESTADO.rojoTexto,
                            }}
                        />
                    )}
                    {item.hint && (
                        <Typography sx={{ fontFamily: FUENTE, fontSize: 11.5, color: COLOR.grisTexto }}>{item.hint}</Typography>
                    )}
                </Box>
            </Card>
        ))}
    </Box>
);

export default KpiRow;
